import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { OrderManipulationViewModel, singleOrder } from "./orderManipulation-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class OrderManipulationView extends View<OrderManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-5EBC1CC4-A252-40FA-A743-E677A6B9992E"
    }
    loadHtml(): string {
        let element = require('./orderManipulation.html').default;
        let style = require('./orderManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set orders(v: ObservableArray<singleOrder>) { this._orders = v; } public get orders(): ObservableArray<singleOrder> { return this._orders;} private _orders: ObservableArray<singleOrder>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    // public set personnelName(v: string) { 
    //     this._personnelName = v;
    //     this.updatePersonnelFullNameAndCode();
    //  } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    // public set personnelLastName(v: string) { 
    //     this._personnelLastName = v;
    //     this.updatePersonnelFullNameAndCode();
    //  } public get personnelLastName(): string { return this._personnelLastName;} private _personnelLastName: string;
    // public set personnelId(v: string) { 
    //     this._personnelId = v;
    //     this.updatePersonnelFullNameAndCode();
    //  } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    // public set personnelFullNameAndCode(v: string) { this._personnelFullNameAndCode = v; } public get personnelFullNameAndCode(): string { return this._personnelFullNameAndCode;} private _personnelFullNameAndCode: string;
    


    // updatePersonnelFullNameAndCode(){
    //     if(stringIsNullOrEmpty(this.personnelName) && stringIsNullOrEmpty(this.personnelLastName) && stringIsNullOrEmpty(this.personnelId)){
    //         this.personnelFullNameAndCode = '';
    //     }else if(stringIsNullOrEmpty(this.personnelId) && stringIsNullOrEmpty(this.personnelName)){
    //         this.personnelFullNameAndCode = this.personnelLastName;
    //     }else if(stringIsNullOrEmpty(this.personnelName) && stringIsNullOrEmpty(this.personnelLastName)){
    //         this.personnelFullNameAndCode = `(${this.personnelId})`;
    //     }else{
    //         this.personnelFullNameAndCode =`${this.personnelName} ${this.personnelLastName} (${this.personnelId})`;
    //     }
    // }

    addNew(){
        this.dataContext.addNew();
    }

}
